<div class="border-card border-0 px-4 py-1 scroll-container" ref="view_trust_profile">
    <NavigationBackButton />
    <div class="card-header card-header-primary shadow rounded-lg mt-2">
          <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
              <ul class="nav nav-tabs" data-tabs="tabs">
                <li class="border rounded-lg me-2 nav-item" :class="{ active: active_tab === 'Compliance Overview' }">
                  <a class="text-white text-decoration-none nav-link text-xxs" @click="set_active_tab('Compliance Overview')">
                    Compliance Overview
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
    <div class="mt-2 mb-5">
      <div class="card card-nav-tabs rounded-lg border-0 shadow">
        
        <div class="card-body">
          <div v-if="active_tab === 'Compliance Overview'">
            <ViewComplianceChecks :entity-id="entity_id" />
          </div>
        </div>
      </div>
    </div>
</div>